import { useState, useEffect } from "react";
import Datepicker from "../../Datepicker";

const StepEventBasics = ({ formData, updateFormData, setFormData }) => {
  const [showDatepicker, setShowDatepicker] = useState(false);
  const [weddingDate, setWeddingDate] = useState(() => {
    return formData.date ? new Date(formData.date) : new Date();
  });

  useEffect(() => {
    if (formData.date) {
      const newDate = new Date(formData.date);
      setWeddingDate((prev) => {
        if (newDate.getTime() !== prev.getTime()) {
          return newDate;
        }
        return prev;
      });
    }
  }, [formData.date]);
  const [coupleNames, setCoupleNames] = useState(() => {
    if (formData.coupleName1 || formData.coupleName2) {
      return { name1: formData.coupleName1 || "", name2: formData.coupleName2 || "" };
    }
    if (formData.eventName && formData.eventName.includes(" i ")) {
      const parts = formData.eventName.split(" i ");
      return { name1: parts[0] || "", name2: parts[1] || "" };
    }
    return { name1: "", name2: "" };
  });

  useEffect(() => {
    if (coupleNames.name1 && coupleNames.name2) {
      const eventName = `${coupleNames.name1} i ${coupleNames.name2}`;
      const emblemLeft = coupleNames.name1.charAt(0).toUpperCase();
      const emblemRight = coupleNames.name2.charAt(0).toUpperCase();
      updateFormData({
        eventName,
        coupleName1: coupleNames.name1,
        coupleName2: coupleNames.name2,
        emblemLeftLetter: emblemLeft,
        emblemRightLetter: emblemRight,
        shareTitle: eventName,
      });
    } else if (coupleNames.name1) {
      updateFormData({
        eventName: coupleNames.name1,
        coupleName1: coupleNames.name1,
        emblemLeftLetter: coupleNames.name1.charAt(0).toUpperCase(),
        shareTitle: coupleNames.name1,
      });
    }
  }, [coupleNames, updateFormData]);


  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-teal-50 mb-4">
          <svg className="w-8 h-8 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900">Tko se vjenčava?</h3>
        <p className="text-sm text-gray-500 mt-1">Unesite imena mladenaca i datum vjenčanja</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="name1" className="block text-sm font-medium text-gray-700 mb-2">
            Prvo ime
          </label>
          <input
            type="text"
            id="name1"
            value={coupleNames.name1}
            onChange={(e) => setCoupleNames((prev) => ({ ...prev, name1: e.target.value }))}
            placeholder="npr. Klara"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-shadow"
          />
        </div>

        <div>
          <label htmlFor="name2" className="block text-sm font-medium text-gray-700 mb-2">
            Drugo ime
          </label>
          <input
            type="text"
            id="name2"
            value={coupleNames.name2}
            onChange={(e) => setCoupleNames((prev) => ({ ...prev, name2: e.target.value }))}
            placeholder="npr. Ivan"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-shadow"
          />
        </div>
      </div>

      {formData.eventName && (
        <div className="text-center py-4">
          <span className="text-2xl font-display text-gray-800">{formData.eventName}</span>
        </div>
      )}

      <div className="pt-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Datum vjenčanja
        </label>
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowDatepicker(!showDatepicker)}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-left text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-shadow flex items-center justify-between"
          >
            <span>
              {formData.date
                ? new Date(formData.date).toLocaleDateString("hr-HR", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : "Odaberite datum"}
            </span>
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </button>

          <div className="absolute z-10 mt-2">
            <Datepicker
              showDatepicker={showDatepicker}
              setShowDatepicker={setShowDatepicker}
              date={weddingDate}
              setDate={setWeddingDate}
              setFormData={setFormData}
              name="date"
            />
          </div>
        </div>
      </div>

      <div className="pt-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Rok za potvrdu dolaska
        </label>
        <div className="relative">
          <input
            type="date"
            value={formData.formExpiryDate ? new Date(formData.formExpiryDate).toISOString().split('T')[0] : ''}
            onChange={(e) => updateFormData({ formExpiryDate: new Date(e.target.value).toISOString() })}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-shadow"
          />
        </div>
        <p className="text-xs text-gray-500 mt-2">
          Gosti će moći potvrditi dolazak do ovog datuma
        </p>
      </div>

      <div className="bg-teal-50 rounded-xl p-4 mt-6">
        <div className="flex items-start">
          <svg className="w-5 h-5 text-teal-600 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="ml-3 text-sm text-teal-700">
            Ove informacije možete promijeniti u bilo kojem trenutku prije objave pozivnice.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepEventBasics;
